// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { isAcclaimedContest } from "@sequentech/ui-core";
var createAcclaimedDisplayContest = function (contestId) { return ({
    contest_id: contestId,
    is_explicit_invalid: false,
    is_decline_to_vote: false,
    is_blank_ballot: false,
    invalid_errors: [],
    invalid_alerts: [],
    choices: [],
}); };
/**
 * Adds display-only entries for acclaimed contests, which are intentionally
 * absent from the encrypted and decoded vote. Decoded entries are preserved
 * verbatim so this presentation helper cannot alter verification results.
 */
export var getConfirmationContests = function (sortedContests, decodedContests) {
    var decodedContestIds = new Set(decodedContests.map(function (_a) {
        var contest_id = _a.contest_id;
        return contest_id;
    }));
    var contestIndexes = new Map(sortedContests.map(function (contest, index) { return [contest.id, index]; }));
    var acclaimedDisplayContests = sortedContests
        .filter(function (contest) { return isAcclaimedContest(contest) && !decodedContestIds.has(contest.id); })
        .map(function (_a) {
        var id = _a.id;
        return createAcclaimedDisplayContest(id);
    });
    return __spreadArray(__spreadArray([], decodedContests, true), acclaimedDisplayContests, true).sort(function (first, second) {
        var _a, _b;
        var firstIndex = (_a = contestIndexes.get(first.contest_id)) !== null && _a !== void 0 ? _a : Number.MAX_SAFE_INTEGER;
        var secondIndex = (_b = contestIndexes.get(second.contest_id)) !== null && _b !== void 0 ? _b : Number.MAX_SAFE_INTEGER;
        return firstIndex - secondIndex;
    });
};
